import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import SortAscIcon from "assets/customIcons/actions/SortAscIcon";
import SortDescIcon from "assets/customIcons/actions/SortDescIcon";
import { body2SemiBold } from "shared/styles/typography";
import { ORDERS } from "shared/types/enums";

import ButtonDefault from "../ButtonDefault";
import { TableSortLabelProps } from "./types";

const TableSortLabel = ({
    children,
    isActive,
    direction,
    onClick
}: TableSortLabelProps) => {
    const { gray900, textDisabled } = colors;

    const getColor = (order: ORDERS) =>
        isActive && order === direction ? gray900 : textDisabled;

    return (
        <ButtonDefault
            onClick={onClick}
            css={[
                body2SemiBold,
                {
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    whiteSpace: "nowrap"
                }
            ]}
        >
            {children}

            <span
                css={css({
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "8px",

                    "& > svg": {
                        fontSize: "8px",
                        transition: "color 200ms cubic-bezier(0.4, 0, 0.2, 1)"
                    }
                })}
            >
                <SortAscIcon
                    css={css({
                        color: getColor(ORDERS.Ascending)
                    })}
                />

                <SortDescIcon
                    css={css({
                        color: getColor(ORDERS.Descending)
                    })}
                />
            </span>
        </ButtonDefault>
    );
};

export default TableSortLabel;
